import React, { useState } from "react";

const Customizer = () => {
    const [isToggled, setIsToggled] = useState(false);
    const [selectedTheme, setSelectedTheme] = useState("semi-dark");

    const changeNavColor = (colorClass) => {
        setSelectedTheme(colorClass); // Update state to control radio buttons

        const semiDarkDiv = document.querySelector(".semidark1");
        if (semiDarkDiv) {
            semiDarkDiv.classList.remove("sem-dark");
            semiDarkDiv.className = `semidark1 ${colorClass}`;
        }
    };

    const changeSideColor = (colorClass) => {
        const htmlTag = document.documentElement;
        if (htmlTag) {
            htmlTag.classList.remove("semi-dark");
            htmlTag.classList.forEach((cls) => {
                if (cls.startsWith("sidebarcolor") || cls.startsWith("color-sidebar")) {
                    htmlTag.classList.remove(cls);
                }
            });
            htmlTag.classList.add(...colorClass.split(" "));
        }
    };

    const handleToggle = () => {
        setIsToggled(!isToggled);
    };

    return (
        <>
            <div className={`switcher-wrapper ${isToggled ? "switcher-toggled" : ""}`}>
                <div className="switcher-btn" onClick={handleToggle}>
                    <i className='bx bx-cog bx-spin'></i>
                </div>
                <div className="switcher-body">
                    <div className="d-flex align-items-center">
                        <h5 className="mb-0 text-uppercase">Theme Customizer</h5>
                        <button type="button" className="btn-close ms-auto close-switcher" aria-label="Close" onClick={handleToggle}></button>
                    </div>
                    <hr />
                    <h6 className="mb-0">Theme Styles</h6>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="form-check">
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="lightmode" 
                                checked={selectedTheme === "Light"} 
                                onChange={() => changeNavColor("Light")} 
                            />
                            <label className="form-check-label" htmlFor="lightmode">Light</label>
                        </div>
                        <div className="form-check">
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="darkmode" 
                                checked={selectedTheme === "dark-theme"} 
                                onChange={() => changeNavColor("dark-theme")} 
                            />
                            <label className="form-check-label" htmlFor="darkmode">Dark</label>
                        </div>
                        <div className="form-check">
                            <input 
                                className="form-check-input" 
                                type="radio" 
                                name="flexRadioDefault" 
                                id="semidark" 
                                checked={selectedTheme === "semi-dark"} 
                                onChange={() => changeNavColor("semi-dark")} 
                            />
                            <label className="form-check-label" htmlFor="semidark">Semi Dark</label>
                        </div>
                    </div>
                    <hr />
                    <div className="form-check">
                        <input 
                            className="form-check-input" 
                            type="radio" 
                            id="minimaltheme" 
                            name="flexRadioDefault" 
                            checked={selectedTheme === "minimal-theme"} 
                            onChange={() => changeNavColor("minimal-theme")} 
                        />  
                        <label className="form-check-label" htmlFor="minimaltheme">Minimal Theme</label>
                    </div>
                    <hr />
                    <h6 className="mb-0">Header Colors</h6>
                    <hr />
                    <div className="header-colors-indigators">
                        <div className="row row-cols-auto g-3">
                            {Array.from({ length: 8 }, (_, index) => {
                                const colorClass = `headercolor${index + 1}`;
                                return (
                                    <div className="col" key={colorClass}>
                                        <div
                                            className={`indigator ${colorClass}`}
                                            onClick={() => changeNavColor(colorClass)}
                                        ></div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <hr />
                    <h6 className="mb-0">Sidebar Colors</h6>
                    <hr />
                    <div className="header-colors-indigators">
                        <div className="row row-cols-auto g-3">
                            {Array.from({ length: 8 }, (_, index) => {
                                const colorClass = `color-sidebar sidebarcolor${index + 1}`;
                                return (
                                    <div className="col" key={colorClass}>
                                        <div
                                            className={`indigator ${colorClass}`}
                                            id={colorClass}
                                            onClick={() => changeSideColor(colorClass)}
                                        ></div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Customizer;
